import { useAuth, withAuthenticationRequired } from 'react-oidc-context';

import { GROUPS_VIEW_REQUIRED_PERMISSION } from '../application/security/permissions';

import DefaultLayout from './layout/DefaultLayout';

function Groups() {
    const permissions: string[] = useAuth().user?.profile.permissions as string[];
    const allPerm = permissions.map((perm) => <li key={perm}>{perm}</li>);
    return (
        <DefaultLayout requiredPermission={GROUPS_VIEW_REQUIRED_PERMISSION}>
            <div>
                <h1>Welcome to groups</h1>
                {useAuth().isLoading ? <div>Loading...</div> : <p> {allPerm}</p>}
            </div>
        </DefaultLayout>
    );
}

export default withAuthenticationRequired(Groups, {
    OnRedirecting: () => <div>Redirecting to the login page...</div>,
});
